const ORCID_URL_PREFIX = 'https://orcid.org/'

export const getOrcidId = (value) => {
  if (!value) {
    return null
  }

  const normalizedValue = String(value).trim()

  if (!normalizedValue) {
    return null
  }

  const idMatch = normalizedValue.match(/(\d{4}-\d{4}-\d{4}-[\dX]{4})/i)

  if (idMatch?.[1]) {
    return idMatch[1].toUpperCase()
  }

  const compactValue = normalizedValue.replace(/[^\dX]/gi, '').toUpperCase()

  if (/^\d{15}[\dX]$/.test(compactValue)) {
    return compactValue.match(/.{1,4}/g)?.join('-') || null
  }

  return null
}

export const getOrcidUrl = (value) => {
  const orcidId = getOrcidId(value)

  return orcidId ? `${ORCID_URL_PREFIX}${orcidId}` : null
}

export const getOrcidLabel = (value) => {
  const orcidId = getOrcidId(value)

  return orcidId || null
}
